var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "evenodd",
    d: "M4,18 L10,18 L10,16 L4,16 L4,18 Z M4,6 L4,8 L20,8 L20,6 L4,6 Z M4,13 L15,13 L15,11 L4,11 L4,13 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortMenu);
export default __webpack_public_path__ + "static/media/sort-menu.c990dd842866b0e83389757acad0c425.svg";
export { ForwardRef as ReactComponent };